module.exports = __webpack_public_path__ + "img/lensflare0.28ecca63.png";